import { TranslationLabels } from "translations/TranslationLabels";

export enum TaskStatusEnum {
  Unknown = 0,
  NotStarted = 1,
  InProgress = 2,
  Deferred = 3,
  WaitingOnSomeoneElse = 4,
  Complete = 5,
  Archived = 6,
  Deleted = 7,
}

/**
 * Gets the localized label for a TaskStatusEnum value.
 */
export function getTaskStatusLabel(value: TaskStatusEnum, i18n: TranslationLabels): string {
  switch (value) {
    case TaskStatusEnum.Unknown:
      return i18n.TaskStatus_Default;
    case TaskStatusEnum.NotStarted:
      return i18n.TaskStatus_NotStarted;
    case TaskStatusEnum.InProgress:
      return i18n.TaskStatus_InProgress;
    case TaskStatusEnum.Deferred:
      return i18n.TaskStatus_Deferred;
    case TaskStatusEnum.WaitingOnSomeoneElse:
      return i18n.TaskStatus_WaitingOnSomeoneElse;
    case TaskStatusEnum.Complete:
      return i18n.TaskStatus_Complete;
    case TaskStatusEnum.Archived:
      return i18n.TaskStatus_Archived;
    case TaskStatusEnum.Deleted:
      return i18n.TaskStatus_Default;
    default:
      return `Unknown TaskStatusEnum: ${value}`;
  }
}
